import { AirballoonOutlineIcon } from './AirballoonOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 67E3294D-960F-4CD8-B4DB-3AAB13D6E17C
 * name airballoon-outline
 * version: 4.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/airballoon-outline.svg
 * tags
 * - Transportation + Flying 
 */
export const HotAirBalloonOutlineIcon = AirballoonOutlineIcon;
export default HotAirBalloonOutlineIcon